<template>
    <div class="search" ref="search">  
        <div class="form">
            <input v-model="searchedText" type="text" class="search__input" :placeholder="lang('Kereses')" @keyup.enter="goToSearchResult()" />
            <button class="search-btn" @click="goToSearchResult()" ></button>
        </div>
    </div>
</template>

<script>
import $ from "jquery"

export default {
    data(){
        return{
            searchedText: ''
        }
    },
    methods:{
       goToSearchResult(){                  
           //set the searched text in the store
            this.$store.dispatch('setSearchedText', this.searchedText)
            this.setDataLayer('search', this.searchedText, '') 
            
            //go to the searchresult route
            let currentRouteName = this.$route.name.substring(0, this.$route.name.indexOf('_'))

            if ( currentRouteName != 'SearchResult' || currentRouteName == undefined || currentRouteName == null || currentRouteName == '') {
                this.$router.push({name: 'SearchResult_' + this.currentLangName()})                
            }                                 

            //delete the text from the input field
            this.searchedText = ''

            //close the search panel on mobile
            this.$refs.search.classList.remove("show")            
            $(".search--mobile-btn").removeClass("opened")

       }   
    }
}
</script>